<template>
  <div class="maintenance">
    <div class="maintenance__header">
      <a :href="marketingWebsiteUrl">
        <img
          v-bind="logo"
          :width="$screen.isMobile($mq) ? 28 : 32"
          :height="$screen.isMobile($mq) ? 28 : 32"
          class="logo"
        >
      </a>
    </div>
    <div class="maintenance__body">
      <div>
        <h1 class="title">We&rsquo;ll be back soon!</h1>
        <div>
          <p>Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. If you need to you can always <a class="maintenance_link" href="mailto:support@donedone.com">contact us</a>, otherwise we&rsquo;ll be back online shortly!</p>
          <div class="footer">
            <p>The DoneDone Team</p>
            <p><a :href="marketingWebsiteUrl" class="link">DoneDone</a></p>
          </div>
        </div>
      </div>  
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import imageFile from '@/assets/img/logos/logo-donedone.svg'

export default defineComponent({
  name: 'Maintenance',

  data() {
    return {
      logo: {
        src: imageFile,
        alt: 'Logo DoneDone',
      },
      marketingWebsiteUrl: 'https://www.donedone.com/',
    }
  },

  head(): any {
    return {
      title: 'Site Maintenance',
    }
  },
})
</script>

<style lang="scss" scoped>
.maintenance {
  &__header {
    position: relative;
    min-width: 320px;
    max-width: 100vw;
    height: $navbar-mobile-height;
    padding: 0 15px;
    line-height: 47px;

    @media (min-width: $--sm) {
      /* we have to add 2px otherwise the heigth changes when text input is added */
      height: $navbar-desktop-height + 2px;
      line-height: 62px;
    }

    .logo {
      display: inline-block;
      vertical-align: middle;

      @media screen and (max-width: $--md) {
        float: left;
        margin-top: 15px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
  }

  &__body {
    display: flex;
    align-items: center;
    width: 100%;
    height: calc(100vh - #{$navbar-mobile-height});
    padding: 0 20px;
    margin-top: -$navbar-mobile-height;

    @include media-breakpoint-up(sm) {
      width: 650px;
      padding: 0;
      margin: 0 auto;
    }

    .title {
      margin-bottom: 18px;
      font-size: 38px;
      text-align: center;

      @include media-breakpoint-up(sm) {
        margin-bottom: 38px;
        font-size: 50px;
      }
    }

    .link {
      color: $light-orange;
      text-decoration: none;

      &:hover {
        color: #333;
        text-decoration: none;
      }
    }

    .footer {
      margin-top: 24px;
    }
  }
}
</style>
